import { createAction, props } from '@ngrx/store';
import { JiraStory } from '../../models/jiraStory';
import { TestCase, TestCaseVersions } from '../../models/testCase';

// Load JIRA Stories
const loadJiraStories = createAction(
  '[TestCaseGenerator] Load JIRA Stories',
  props<{ projectId: string; jiraConnection: string; }>()
);
const loadJiraStoriesSuccess = createAction(
  '[TestCaseGenerator] Load JIRA Stories Success',
  props<{ stories: JiraStory[] }>()
);
const loadJiraStoriesFailure = createAction(
  '[TestCaseGenerator] Load JIRA Stories Failure',
  props<{ error: string }>()
);

// Delete JIRA Stories
const deleteJiraStories = createAction(
  '[TestCaseGenerator] Delete JIRA Stories',
  props<{ projectId: string }>()
);
const deleteJiraStoriesSuccess = createAction(
  '[TestCaseGenerator] Delete JIRA Stories Success'
);
const deleteJiraStoriesFailure = createAction(
  '[TestCaseGenerator] Delete JIRA Stories Failure',
  props<{ error: string }>()
);

// Generate Test Cases
const generateTestCases = createAction(
  '[TestCaseGenerator] Generate Test Cases',
  props<{ selectedUserStories: any }>()
);
const generateTestCasesProgressMessages = createAction(
  '[TestCaseGenerator] Generate Test Cases Progress Messages',
  props<{ message: any}>()
);
const generateTestCasesSuccess = createAction(
  '[TestCaseGenerator] Generate Test Cases Success',
  props<{ versionId: any,testCases: any ,}>()
);
const generateTestCasesFailure = createAction(
  '[TestCaseGenerator] Generate Test Cases Failure',
  props<{ error: string }>()
);

// Update Test Case
const updateTestCase = createAction(
  '[TestCaseGenerator] Update Test Case',
  props<{ testCases: Array<{ projectId: string; testcaseId: string; userInput: string; versionId?: string }>, projectId: string }>()
);
const updateTestCaseSuccess = createAction(
  '[TestCaseGenerator] Update Test Case Success',
  props<{ testCase: TestCase }>()
);
const updateTestCaseFailure = createAction(
  '[TestCaseGenerator] Update Test Case Failure',
  props<{ error: string }>()
);

// Load Test Case Versions
const loadTestCaseVersions = createAction(
  '[TestCaseGenerator] Load Test Case Versions',
  props<{ projectId: string;}>()
);
const loadTestCaseVersionsSuccess = createAction(
  '[TestCaseGenerator] Load Test Case Versions Success',
  props<{ versions: TestCaseVersions[] }>()
);
const loadTestCaseVersionsFailure = createAction(
  '[TestCaseGenerator] Load Test Case Versions Failure',
  props<{ error: string }>()
);

// Load Test Case Details By Version Id
const loadTestCaseDetailsByVersionId = createAction(
  '[TestCaseGenerator] Load Test Case Details By Version Id',
  props<{ projectId: string; versionId: string }>()
);

const loadTestCaseDetailsByVersionIdSuccess = createAction(
  '[TestCaseGenerator] Load Test Case Details By Version Id Success',
  props<{ testCases: TestCase[] }>()
);

const loadTestCaseDetailsByVersionIdFailure = createAction(
  '[TestCaseGenerator] Load Test Case Details By Version Id Failure',
  props<{ error: any }>()
);

//Clear TestCase Versions
const clearTestCaseVersions = createAction(
  '[TestCaseGenerator] Clear Test Case Versions'
);

export const TestCaseGeneratorActions = {
  loadJiraStories,
  loadJiraStoriesSuccess,
  loadJiraStoriesFailure,
  deleteJiraStories,
  deleteJiraStoriesSuccess,
  deleteJiraStoriesFailure,
  generateTestCases,
  generateTestCasesProgressMessages,
  generateTestCasesSuccess,
  generateTestCasesFailure,
  updateTestCase,
  updateTestCaseSuccess,
  updateTestCaseFailure,
  loadTestCaseVersions,
  loadTestCaseVersionsSuccess,
  loadTestCaseVersionsFailure,
  loadTestCaseDetailsByVersionId,
  loadTestCaseDetailsByVersionIdSuccess,
  loadTestCaseDetailsByVersionIdFailure,
  clearTestCaseVersions
}